import { SettingsLayoutModel, getModel } from "client/Api/SettingsLayout/settingsLayout";
import { AutoFetchStoreData, createAutoFetchStore } from "client/zustand/createAutoFetchStore";
import create, { UseStore } from "zustand";

export const sidebarMenuStore = createAutoFetchStore<SettingsLayoutModel | null>(
	null,
	getModel
);

export const useSidebarMenuStore: UseStore<AutoFetchStoreData<SettingsLayoutModel | null>> = create(sidebarMenuStore);